<template>
	<el-container class="friend-tag-page">
		<resizable-aside :default-width="260" :min-width="200" :max-width="500" storage-key="friend-tag-aside-width">
			<div class="header" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
				<span class="title">{{ $t('friend.tags') }}</span>
				<el-button plain class="add-btn" icon="el-icon-plus" :title="$t('friend.createTag')"
					@click="onCreateTag"></el-button>
			</div>
			<el-scrollbar class="tag-items">
				<div v-for="tag in tags" :key="tag.id" class="tag-item" :class="activeTag.id === tag.id ? 'active' : ''"
					@click="onActiveTag(tag)">
					<div class="tag-item-avatar">
						<head-image :size="42" :name="tag.tagName" :is-show-user-info="false"></head-image>
					</div>
					<div class="tag-item-info">
						<div class="tag-item-name">{{ tag.tagName }}</div>
						<div class="tag-item-count">{{ $t('friend.membersCount', { n: tag.count }) }}</div>
					</div>
					<div class="tag-item-actions" @click.stop>
						<i class="icon iconfont icon-modify" :title="$t('friend.renameTag')" @click="onRenameTag(tag)"></i>
						<i class="el-icon-delete" :title="$t('friend.deleteTag')" @click="onDeleteTag(tag)"></i>
					</div>
				</div>
				<div v-if="!tags.length" class="empty-tip">{{ $t('friend.noTagTip') }}</div>
			</el-scrollbar>
		</resizable-aside>
		<el-container v-if="activeTagInfo.id" class="container">
			<div class="header" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
				<div class="tag-title">{{ activeTagInfo.tagName }}</div>
				<el-input class="search-text" size="small" :placeholder="$t('common.search')" v-model="searchText">
					<i class="el-icon-search el-input__icon" slot="prefix"> </i>
				</el-input>
				<el-button plain class="add-member-btn" icon="el-icon-plus" :title="$t('friend.addTagMember')"
					@click="openMemberDialog()"></el-button>
			</div>
			<el-scrollbar class="member-items">
				<div v-for="(friends, i) in memberValues" :key="i">
					<div class="letter">{{ memberKeys[i] }}</div>
					<div v-for="friend in friends" :key="friend.id">
						<friend-item :id="friend.id" :friend="friend" @click.native="onActiveMember(friend)">
						</friend-item>
					</div>
					<div v-if="i < memberValues.length - 1" class="divider"></div>
				</div>
				<div v-if="!memberValues.length" class="empty-tip">{{ $t('friend.tagMemberEmpty') }}</div>
			</el-scrollbar>
		</el-container>
		<el-container v-else class="container">
			<div class="empty-tip center">{{ $t('friend.selectTagTip') }}</div>
		</el-container>
		<el-dialog v-dialogDrag :title="$t('friend.addTagMember')" :visible.sync="showMemberDialog" width="500px">
			<div class="member-dialog">
				<el-input :placeholder="$t('common.search')" v-model="memberSearch" size="small">
					<i class="el-icon-search el-input__icon" slot="prefix"> </i>
				</el-input>
				<el-scrollbar class="member-scroll">
					<div v-for="friend in showMembers" :key="friend.id" class="member-item">
						<friend-item :friend="friend" :menu="false" @click.native="toggleMember(friend)">
							<el-checkbox :value="memberCheck.includes(friend.id)" class="check-box" @click.native.stop="toggleMember(friend)">
							</el-checkbox>
						</friend-item>
					</div>
					<div v-if="!showMembers.length" class="empty-tip">{{ $t('friend.noSearchResultTip') }}</div>
				</el-scrollbar>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="showMemberDialog = false">{{ $t('common.cancel') }}</el-button>
				<el-button type="primary" :loading="savingMembers" @click="saveMembers()">{{ $t('common.confirm') }}</el-button>
			</span>
		</el-dialog>
	</el-container>
</template>

<script>
import FriendItem from "../components/friend/FriendItem.vue";
import HeadImage from "../components/common/HeadImage.vue";
import ResizableAside from "../components/common/ResizableAside.vue";
import { pinyin } from 'pinyin-pro';

export default {
	name: "friendTag",
	components: {
		FriendItem,
		HeadImage,
		ResizableAside
	},
	data() {
		return {
			searchText: "",
			activeTag: {},
			showMemberDialog: false,
			memberSearch: "",
			memberCheck: [],
			savingMembers: false
		}
	},
	computed: {
		tags() {
			return this.friendStore.tags;
		},
		// 从store按id取最新标签数据,避免loadTags后旧引用导致成员列表不刷新
		activeTagInfo() {
			return this.tags.find(tag => tag.id === this.activeTag.id) || this.activeTag;
		},
		showMembers() {
			return this.friendStore.friends.filter(f => !f.deleted
				&& (this.memberSearch ? f.showNickName.includes(this.memberSearch) : true));
		},
		memberMap() {
			let map = new Map();
			let friendIds = this.activeTagInfo.friendIds || [];
			this.friendStore.friends.forEach((f) => {
				if (f.deleted || !friendIds.includes(f.id)) {
					return;
				}
				if (this.searchText && !f.showNickName.includes(this.searchText)) {
					return;
				}
				let letter = this.firstLetter(f.showNickName).toUpperCase();
				if (!this.isEnglish(letter)) {
					letter = "#";
				}
				if (map.has(letter)) {
					map.get(letter).push(f);
				} else {
					map.set(letter, [f]);
				}
			})
			let arrayObj = Array.from(map);
			arrayObj.sort((a, b) => {
				if (a[0] == '#') return 1;
				if (b[0] == '#') return -1;
				return a[0].localeCompare(b[0]);
			});
			return new Map(arrayObj.map(i => [i[0], i[1]]));
		},
		memberKeys() {
			return Array.from(this.memberMap.keys());
		},
		memberValues() {
			return Array.from(this.memberMap.values());
		}
	},
	methods: {
		onActiveTag(tag) {
			this.activeTag = tag;
			this.searchText = "";
		},
		onActiveMember(friend) {
			this.$router.push("/home/friend?id=" + friend.id);
		},
		onCreateTag() {
			this.$prompt(this.$t('friend.inputTagName'), this.$t('friend.createTag'), {
				confirmButtonText: this.$t('common.ok'),
				cancelButtonText: this.$t('common.cancel'),
				inputValidator: (value) => {
					if (value && value.length > 32) {
						return this.$t('friend.tagNameMax32');
					}
				}
			}).then((o) => {
				if (!o.value || !o.value.trim()) {
					return;
				}
				this.$http({
					url: '/friend/tag/create',
					method: 'POST',
					data: { tagName: o.value.trim() }
				}).then(() => {
					this.friendStore.loadTags();
				})
			})
		},
		onRenameTag(tag) {
			this.$prompt(this.$t('friend.inputTagName'), this.$t('friend.renameTag'), {
				inputValue: tag.tagName,
				confirmButtonText: this.$t('common.ok'),
				cancelButtonText: this.$t('common.cancel'),
				inputValidator: (value) => {
					if (value && value.length > 32) {
						return this.$t('friend.tagNameMax32');
					}
				}
			}).then((o) => {
				if (!o.value || !o.value.trim()) {
					return;
				}
				this.$http({
					url: '/friend/tag/rename',
					method: 'PUT',
					data: { tagId: tag.id, tagName: o.value.trim() }
				}).then(() => {
					this.friendStore.loadTags();
				})
			})
		},
		onDeleteTag(tag) {
			this.$confirm(this.$t('friend.deleteTagConfirm', { name: tag.tagName }), this.$t('friend.deleteTag'), {
				confirmButtonText: this.$t('common.ok'),
				cancelButtonText: this.$t('common.cancel'),
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/friend/tag/delete/${tag.id}`,
					method: 'DELETE'
				}).then(() => {
					if (this.activeTag.id === tag.id) {
						this.activeTag = {};
					}
					this.friendStore.loadTags();
				})
			})
		},
		openMemberDialog() {
			this.memberCheck = (this.activeTagInfo.friendIds || []).slice();
			this.memberSearch = "";
			this.showMemberDialog = true;
		},
		toggleMember(friend) {
			let idx = this.memberCheck.indexOf(friend.id);
			if (idx >= 0) {
				this.memberCheck.splice(idx, 1);
			} else {
				this.memberCheck.push(friend.id);
			}
		},
		saveMembers() {
			this.savingMembers = true;
			this.$http({
				url: '/friend/tag/set-members',
				method: 'PUT',
				data: { tagId: this.activeTag.id, friendIds: this.memberCheck }
			}).then(() => {
				this.friendStore.loadTags();
				this.savingMembers = false;
				this.showMemberDialog = false;
			}).catch(() => {
				this.savingMembers = false;
			})
		},
		firstLetter(strText) {
			let pinyinOptions = {
				toneType: 'none',
				type: 'normal'
			};
			let pyText = pinyin(strText, pinyinOptions);
			return pyText[0];
		},
		isEnglish(character) {
			return /^[A-Za-z]+$/.test(character);
		}
	}
}
</script>

<style scoped lang="scss">
.friend-tag-page {
	.header {
		height: 60px;
		display: flex;
		align-items: center;
		padding: 0 12px;

		.title {
			flex: 1;
			font-size: var(--im-font-size-larger);
			text-align: left;
			font-weight: 600;
		}

		.add-btn {
			padding: 8px;
			margin: 5px;
			font-size: 16px;
			border-radius: 50%;
			background: var(--im-background-active);
			color: var(--im-color-primary);
			transition: all 0.3s ease;
			font-weight: 600;
			border: var(--im-border);

			&:hover {
				background: var(--im-background-active-dark);
				transform: scale(1.1);
			}
		}

		.search-text {
			width: 220px;
			margin-right: 8px;
		}

		.tag-title {
			flex: 1;
			font-size: var(--im-font-size-larger);
			font-weight: 600;
			text-align: left;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.add-member-btn {
			padding: 8px;
			margin: 5px;
			font-size: 16px;
			border-radius: 50%;
			background: var(--im-background-active);
			color: var(--im-color-primary);
			transition: all 0.3s ease;
			font-weight: 600;
			border: var(--im-border);

			&:hover {
				background: var(--im-background-active-dark);
				transform: scale(1.1);
			}
		}
	}

	.tag-items {
		flex: 1;

		.tag-item {
			height: 50px;
			display: flex;
			align-items: center;
			padding: 5px 10px;
			white-space: nowrap;
			cursor: pointer;
			border-radius: 12px;

			&:hover {
				background-color: var(--im-background-active);

				.tag-item-actions {
					display: flex;
				}
			}

			&.active {
				background-color: var(--im-background-active-dark);
			}

			.tag-item-avatar {
				display: flex;
				align-items: center;
			}

			.tag-item-info {
				flex: 1;
				display: flex;
				flex-direction: column;
				padding-left: 10px;
				text-align: left;
				overflow: hidden;

				.tag-item-name {
					font-size: var(--im-font-size);
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.tag-item-count {
					font-size: var(--im-font-size-small);
					color: var(--im-text-color-light);
				}
			}

			.tag-item-actions {
				display: none;
				align-items: center;
				gap: 8px;
				color: var(--im-color-primary);

				i {
					cursor: pointer;
					font-size: 16px;

					&:hover {
						transform: scale(1.15);
					}
				}
			}
		}
	}

	.empty-tip {
		text-align: center;
		color: var(--im-text-color-light);
		padding: 20px;
		font-size: var(--im-font-size-small);

		&.center {
			margin-top: 20%;
		}
	}

	.member-items {
		flex: 1;

		.divider {
			border-bottom: 1px #ddd solid;
			margin: 10px;
		}

		.letter {
			text-align: left;
			font-size: var(--im-larger-size-larger);
			padding: 5px 15px;
			color: var(--im-text-color-light);
		}
	}

	.container {
		display: flex;
		flex-direction: column;
	}

	.member-dialog {
		.member-scroll {
			height: 360px;
			margin-top: 10px;

			.member-item {
				.check-box {
					margin-right: 10px;
				}
			}
		}
	}
}
</style>
